import React, { createContext, useContext } from 'react';
import { useConfig } from '../hooks/useConfig';

const ConfigContext = createContext(null);

/**
 * Config context provider
 * Provides config state, loading, and error to all children
 */
export function ConfigProvider({ children }) {
  const { config, loading, error } = useConfig();

  return (
    <ConfigContext.Provider value={{ config, loading, error }}>
      {children}
    </ConfigContext.Provider>
  );
}

/**
 * Hook to access config context
 * @returns {{ config: object, loading: boolean, error: Error|null }}
 */
export function useConfigContext() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfigContext must be used within ConfigProvider');
  }
  return context;
}
